import { api } from '@/config/api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface LeadAdFormQuestion {
  id: string;
  key: string;
  label: string;
  type: string;
}

export interface LeadAdForm {
  _id: string;
  formUid: string;
  companyUid: string;
  metaFormId: string;
  metaPageId: string;
  name: string;
  locale?: string;
  privacyPolicyUrl?: string;
  thankYouMessage?: string;
  questions: LeadAdFormQuestion[];
  greetingTemplateUid?: string;
  autoGreetEnabled: boolean;
  lastFetchedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateLeadAdFormPayload {
  greetingTemplateUid?: string;
  autoGreetEnabled?: boolean;
}

// ─── Service ─────────────────────────────────────────────────────────────────

export const leadAdFormsService = {
  list: async (): Promise<LeadAdForm[]> =>
    (await api.get('/slighter_crm/settings/lead-ad-forms')).data,

  get: async (formUid: string): Promise<LeadAdForm> =>
    (await api.get(`/slighter_crm/settings/lead-ad-forms/${formUid}`)).data,

  update: async (formUid: string, payload: UpdateLeadAdFormPayload): Promise<LeadAdForm> =>
    (await api.patch(`/slighter_crm/settings/lead-ad-forms/${formUid}`, payload)).data,

  refetch: async (formUid: string): Promise<LeadAdForm> =>
    (await api.post(`/slighter_crm/settings/lead-ad-forms/${formUid}/refetch`)).data,
};
